import {usePermissions} from '@dms/shared';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

interface IntegrationWidgetsSubSectionProps {
  // Resolved by the caller: reading the route here returned the host entity's id once the form
  // was embedded outside /vehicles. Undefined while creating, so the widgets skip their queries.
  vehicleId: string | undefined;
}

export function IntegrationWidgetsSubSection(props: IntegrationWidgetsSubSectionProps) {
  const [canReadBusinessCase] = usePermissions({permissionKeys: ['businessCaseRead']});

  return (
    <VFKit.SubSection data-testid="cebia-widgets">
      <VFKit.ShowWhen when={canReadBusinessCase}>
        <VFKit.Suspense>
          <VFKit.CebiaAutotracerWidget vehicleId={props.vehicleId} />
          <VFKit.CebiaProductionYearWidget vehicleId={props.vehicleId} />
        </VFKit.Suspense>
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
